import { apiFetch } from "@/lib/api";

export type PurchaseInvoiceListRow = {
  id: string;
  mv_id: string | null;
  mv_number: string | null;
  mv_status: string | null;
  document_type: string | null;
  created_at: string | null;
  supplier_name: string | null;
  purchase_order_id: string | null;
  purchase_order_number: string | null;
};

export type PurchaseInvoiceDetailHeader = {
  id: string;
  mv_id: string | null;
  mv_number: string | null;
  mv_status: string | null;
  document_type: string | null;
  reference: string | null;
  created_at: string | null;
  mv_updated_at: string | null;
  currency: string | null;
  payment_terms: string | null;
  payment_method: string | null;
  qb_id: string | null;
  supplier_id: string | null;
  supplier_name: string | null;
  purchase_order_id: string | null;
  purchase_order_number: string | null;
  purchase_order_mv_id: string | null;
  purchase_order_system_of_record: string | null;
  location_code: string | null;
  can_cancel: boolean;
  cancel_blocked_reason: string | null;
};

export type PurchaseInvoiceDetailLine = {
  id: string;
  sku: string;
  description: string | null;
  quantity: number;
  unit_price: number | null;
  line_total: number | null;
  purchase_order_item_id: string | null;
};

export type PurchaseInvoiceDetailResponse = {
  purchase_invoice: PurchaseInvoiceDetailHeader;
  lines: PurchaseInvoiceDetailLine[];
};

export async function fetchPurchaseInvoiceList(query: string, limit = 100): Promise<PurchaseInvoiceListRow[]> {
  const data = await apiFetch<{ rows: PurchaseInvoiceListRow[] }>("/api/mrp/purchase-invoices", {
    query: { q: query.trim(), limit: String(limit) },
  });
  return data.rows;
}

export function purchaseInvoiceDetailQueryKey(purchaseInvoiceId: number): readonly [
  "mrp-purchase-invoice",
  "detail",
  number,
] {
  return ["mrp-purchase-invoice", "detail", purchaseInvoiceId];
}

export async function fetchPurchaseInvoiceDetail(id: number): Promise<PurchaseInvoiceDetailResponse> {
  return apiFetch<PurchaseInvoiceDetailResponse>(`/api/mrp/purchase-invoices/${encodeURIComponent(String(id))}`);
}

export async function cancelPurchaseInvoice(id: number): Promise<{
  cancelled: true;
  mv_document_id: number;
}> {
  return apiFetch(`/api/mrp/purchase-invoices/${encodeURIComponent(String(id))}/cancel`, {
    method: "POST",
  });
}

export function filterPurchaseInvoiceListRowsClient(
  rows: PurchaseInvoiceListRow[],
  searchText: string,
): PurchaseInvoiceListRow[] {
  const trimmed = searchText.trim().toLowerCase();
  if (trimmed === "") {
    return rows;
  }
  return rows.filter((row) => {
    const haystack = [
      row.id,
      row.mv_id,
      row.mv_number,
      row.mv_status,
      row.document_type,
      row.supplier_name,
      row.purchase_order_number,
    ]
      .filter((piece) => piece != null && String(piece).trim() !== "")
      .join(" ")
      .toLowerCase();
    return haystack.includes(trimmed);
  });
}
